<template>
    <div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="词根数据" name="view1">
                <view1 ref="view1"></view1>
            </el-tab-pane>
            <el-tab-pane label="否定词根数据" name="view2">
                <view2 ref="view2"></view2>
            </el-tab-pane>
            <el-tab-pane label="种子词库数据" name="view3">
                <view3
                    :datasrow="datasrow"
                    @getList="getList"
                    v-if="activeName === 'view3'"
                    ref="view3"
                ></view3>
            </el-tab-pane>
            <el-tab-pane label="已打广告词数据" name="view4">
                <view4 ref="view4"></view4>
            </el-tab-pane>
            <el-tab-pane label="无效词数据" name="view5">
                <view5 ref="view5"></view5>
            </el-tab-pane>
            <el-tab-pane label="词库排除数据" name="view6">
                <view6 ref="view6"></view6>
            </el-tab-pane>
            <el-tab-pane label="核心词根数据" name="view7">
                <view7 ref="view7"></view7>
            </el-tab-pane>
            <el-tab-pane label="对比Asin数据" name="view8">
                <View8 :datasrow="datasrow" ref="view8"></View8>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import View1 from "./view1";
import View2 from "./view2";
import View3 from "./view3";
import View4 from "./view4";
import View5 from "./view5";
import View6 from "./view6";
import View7 from "./view7";
import View8 from "./view8";
export default {
    components: { View1, View2, View3, View4, View5, View6, View7, View8 },
    props: {
        datasrow: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            activeName: "view1"
        };
    },
    methods: {
        handleClick() {
            if (this.activeName == "view1") {
                this.$refs.view1.getList(this.datasrow.asin,this.datasrow.state);
            } else if (this.activeName == "view2") {
                this.$refs.view2.getList(this.datasrow.asin,this.datasrow.state);
            } else if (this.activeName == "view4") {
                this.$refs.view4.getList(this.datasrow.asin,this.datasrow.state);
            } else if (this.activeName == "view5") {
                this.$refs.view5.getList(this.datasrow.asin,this.datasrow.state);
            } else if (this.activeName == "view6") {
                this.$refs.view6.getList(this.datasrow.asin,this.datasrow.state);
            } else if (this.activeName == "view7") {
                this.$refs.view7.getList(this.datasrow.asin,this.datasrow.state);
            } else if (this.activeName == "view8") {
                this.$refs.view8.getList(this.datasrow.asin,this.datasrow.state);
            }
        },
        getList() {
            this.$emit("getList");
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
/deep/ .el-tabs__header {
    margin: 0 !important;
}
</style>
